module.exports = {
  template: require('./location-form.pug')()
  controller: require('./location-form.ctrl')
  bindings:
    salon: '<'
}
